import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ProductivityEditService } from '../../service/productivity-edit/productivity-edit.service';

@Component({
	selector: 'app-productivity-edit',
	templateUrl: './productivity-edit.component.html',
	providers: [
		ProductivityEditService,
		HttpModule
	]
})
export class ProductivityEditComponent implements OnInit {

	private token;
	private sub: any;
	prodForm: FormGroup;
	ID: string;
	Nome: string;
	Regiao: string;
	Ativo: boolean;
	public allRegions: any[] = [];
	public checkRegion: any[] = [];
	public otherRegions: any[] = [];
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private productivityEditService: ProductivityEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.prodForm = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Regiao': [this.allRegions[0], Validators.required],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.productivityEditService.loadProductivity(this.token, this.ID).subscribe(result => {
				var updateProd = result.Result;
				this.prodForm.setValue({
					ID: updateProd.ID,
					Nome: updateProd.Nome,
					Regiao: updateProd.Regiao,
					Ativo: updateProd.Ativo
				});

				this.checkRegion = result.Result.RegiaoID;

				if (result.Success == true) {
					this.productivityEditService.getRegion(this.token).subscribe(result => {
						this.otherRegions = result.Result;

						for (var i = this.otherRegions.length - 1; i >= 0; i--) {

							if (this.otherRegions[i].ID == this.checkRegion) {
								this.otherRegions[i].checked = true;
							}
						}
					});
				}
			})
		}, error => {
			console.log(error);
			
		});
	}

	editProductivity(value: any) {
		var selRegion = $("#selRegion").val();

		var ListCosts = this.otherRegions.filter(opt => opt.checked).map(opt => opt.ID);
		var objEditProd = {
			Ativo: value.Ativo,
			ID: value.ID,
			Nome: value.Nome,
			RegiaoID: selRegion
		};

		this.productivityEditService.editProductivity(this.token, objEditProd).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Produtividade Média editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/produtividade-media');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/produtividade-media');
	}

}


// WEBPACK FOOTER //
// ./src/app/productivity/component/productivity-edit/productivity-edit.component.ts